import { put } from 'services/api';
import { TicketTypeProps } from './types';

export const reorderTicketTypesPut = async (ticketTypes: TicketTypeProps[]) => {
	return await put(
		'/ticket_types/reorder',
		ticketTypes.map(({ iD, orderIndex }) => ({ ID: iD, order_index: orderIndex }))
	);
};
